<template>
  <div class="form p-12">
    <div v-for="section in sections" :key="section.key" class="mt-4 p-2 tank">
      <div class="f-500 black flex justify-between">
        <div class="flex">{{ section.label }}</div>
        <div v-if="section.key === 'Center'" class="flex pr-1 pt-1 cursor-pointer" @click="showCenter = !showCenter">
          <svg v-if="showCenter" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
            stroke-width="2.5" stroke="currentColor" class="f-500 black w-4 h-4">
            <path stroke-linecap="round" stroke-linejoin="round" d="M4.5 15.75l7.5-7.5 7.5 7.5" />
          </svg>
          <svg v-else xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2.5"
            stroke="currentColor" class="f-500 black w-4 h-4">
            <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5" />
          </svg>
        </div>
      </div>
      <el-table v-if="section.key !== 'Center' || showCenter" :data="section.rows" :header-cell-class-name="headerClass" class="mt-4">
        <el-table-column align="center" label="Tank" prop="formItem" width="48"></el-table-column>
        <el-table-column label="Product" min-width="70">
          <template slot-scope="scope">
            <el-autocomplete v-model="scope.row.product" :disabled="disabled" size="mini"
              popper-class="lc-product-popper"
              :fetch-suggestions="(q, cb) => querySearchSection(section.key, q, cb)">
              <template #default="{ item }">
                <div v-if="item.old" class="flex justify-between">
                  <div class="value">{{ item.value }}</div>
                  <div>
                    <i class="el-icon-circle-close cursor-pointer fs-15" style="color: red"
                      @click="deleteTankProduct(scope.row, item.data)"></i>
                  </div>
                </div>
                <div v-else class="flex justify-between" @click="addMoreProduct(item.value)">
                  <div class="value">{{ item.value }}</div>
                  <div>
                    <el-button plain type="primary" style="padding:0; border-width: 0px; border-radius: 25px">
                      <i class="el-icon-circle-plus cursor-pointer fs-15"></i>
                    </el-button>
                  </div>
                </div>
              </template>
            </el-autocomplete>
          </template>
        </el-table-column>
        <el-table-column label="Before Loading" align="center">
          <el-table-column label="Ullage" min-width="62">
            <template slot-scope="scope">
              <el-input v-model="scope.row.beforeUllage" :disabled="disabled" size="mini" type="number"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="Gross Volume" min-width="62">
            <template slot-scope="scope">
              <el-input v-model="scope.row.beforeVolume" :disabled="disabled" size="mini" type="number"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="Temp" min-width="62">
            <template slot-scope="scope">
              <el-input v-model="scope.row.beforeTemp" :disabled="disabled" size="mini" type="number"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="Water" min-width="62">
            <template slot-scope="scope">
              <el-input v-model="scope.row.beforeWater" :disabled="disabled" size="mini" type="number"></el-input>
            </template>
          </el-table-column>
        </el-table-column>
        <el-table-column label="After Loading" align="center">
          <el-table-column label="Ullage" min-width="62">
            <template slot-scope="scope">
              <el-input v-model="scope.row.afterUllage" :disabled="disabled" size="mini" type="number"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="Gross Volume" min-width="62">
            <template slot-scope="scope">
              <el-input v-model="scope.row.afterVolume" :disabled="disabled" size="mini" type="number"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="Temp" min-width="62">
            <template slot-scope="scope">
              <el-input v-model="scope.row.afterTemp" :disabled="disabled" size="mini" type="number"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="Water" min-width="62">
            <template slot-scope="scope">
              <el-input v-model="scope.row.afterWater" :disabled="disabled" size="mini" type="number"></el-input>
            </template>
          </el-table-column>
        </el-table-column>
        <el-table-column align="center" label="" width="40">
          <template slot="header"><i class="el-icon-delete fs-15"></i></template>
          <template slot-scope="scope">
            <i v-if="!disabled" class="el-icon-circle-close cursor-pointer fs-15" style="color: red"
              @click="clearItem(scope.row)"></i>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- Line Content -->
    <div class="item mt-8">
      <div class="fs-12 black f-600" style="width: 100px">Line Content:</div>
      <div class="value pl-5 w-full">
        <el-radio-group v-model="lineContentOption" size="mini" :disabled="disabled">
          <el-radio label="Include">Include</el-radio>
          <el-radio label="Number">Number</el-radio>
        </el-radio-group>
        <div v-if="lineContentOption === 'Number'" class="mt-2">
          <el-input-number v-model="dataForm.lineContent" :precision="3" :disabled="disabled" size="mini">
          </el-input-number>
        </div>
      </div>
    </div>

    <!-- Draft -->
    <div class="f-500 black mt-8">Draft</div>
    <div class="flex flex-wrap justify-between">
      <div>
        <div class="f-500 fs-13 mt-4 black">Before Loading / Discharging</div>
        <div class="item mt-4">
          <div class="fs-12 f-600 label">Forward:</div>
          <div class="value">
            <el-input v-model="dataForm.forward" :disabled="disabled" size="mini" type="number" style="width: 170px">
              <template slot="append"><el-button>Metre</el-button></template>
            </el-input>
          </div>
        </div>
        <div class="item mt-4">
          <div class="fs-12 f-600 label">Aft:</div>
          <div class="value">
            <el-input v-model="dataForm.aft" :disabled="disabled" size="mini" type="number" style="width: 170px">
              <template slot="append"><el-button>Metre</el-button></template>
            </el-input>
          </div>
        </div>
      </div>
      <div>
        <div class="f-500 fs-13 mt-4 black">After Loading / Discharging</div>
        <div class="item mt-4">
          <div class="fs-12 f-600 label">Forward:</div>
          <div class="value">
            <el-input v-model="dataForm.afterForward" :disabled="disabled" size="mini" type="number" style="width: 170px">
              <template slot="append"><el-button>Metre</el-button></template>
            </el-input>
          </div>
        </div>
        <div class="item mt-4">
          <div class="fs-12 f-600 label">Aft:</div>
          <div class="value">
            <el-input v-model="dataForm.afterAft" :disabled="disabled" size="mini" type="number" style="width: 170px">
              <template slot="append"><el-button>Metre</el-button></template>
            </el-input>
          </div>
        </div>
      </div>
      <div>
        <div class="f-500 fs-13 mt-4 black">Terminal Loaded</div>
        <div class="item mt-4">
          <div class="fs-12 f-600 label"><span style="color:red">*</span>Figure:</div>
          <div class="value">
            <el-input v-model="dataForm.terminalLoaded" :disabled="disabled" size="mini" inputmode="decimal"
              style="width: 150px" @input="dataForm.terminalLoaded = numberOnly($event)">
              <template slot="append"><el-button>MT</el-button></template>
            </el-input>
          </div>
        </div>
      </div>
    </div>

    <!-- Ship Figure -->
    <div class="f-500 black mt-8">
      <span style="color:red">*</span>Ship Figure
    </div>
    <el-table :data="dataForm.listItem" class="mt-4 ship-figure">
      <el-table-column label="Product Name">
        <template slot-scope="scope">
          <el-autocomplete v-model="scope.row.name" :disabled="disabled" popper-class="lc-product-popper"
            :fetch-suggestions="querySearchAllAsync">
            <template #default="{ item }">
              <div v-if="item.old" class="flex justify-between">
                <div class="value">{{ item.value }}</div>
                <div>
                  <i class="el-icon-circle-close cursor-pointer fs-15" style="color: red"
                    @click="deleteProduct(scope.$index, item.data)"></i>
                </div>
              </div>
              <div v-else class="flex justify-between" @click="addMoreProduct(item.value)">
                <div class="value">{{ item.value }}</div>
                <div>
                  <el-button plain type="primary" style="padding:0; border-width: 0px; border-radius: 25px">
                    <i class="el-icon-circle-plus cursor-pointer fs-15"></i>
                  </el-button>
                </div>
              </div>
            </template>
          </el-autocomplete>
        </template>
      </el-table-column>
      <el-table-column label="Gross Volume">
        <template slot-scope="scope">
          <el-input v-model="scope.row.grossVolume" :disabled="disabled" type="number"></el-input>
        </template>
      </el-table-column>
      <el-table-column label="Volume(Less Water)">
        <template slot-scope="scope">
          <el-input v-model="scope.row.waterVolume" :disabled="disabled" type="number"></el-input>
        </template>
      </el-table-column>
      <el-table-column label="Volume Correction Factor">
        <template slot-scope="scope">
          <el-input v-model="scope.row.volumeCorrectionFactor" :disabled="disabled" type="number"></el-input>
        </template>
      </el-table-column>
      <el-table-column label="Nett Volume">
        <template slot-scope="scope">
          <el-input v-model="scope.row.nettVolume" :disabled="disabled" type="number"></el-input>
        </template>
      </el-table-column>
      <el-table-column label="Density @ 15°C">
        <template slot-scope="scope">
          <el-input v-model="scope.row.density" :disabled="disabled" type="number"></el-input>
        </template>
      </el-table-column>
      <el-table-column label="Metric Tons">
        <template slot-scope="scope">
          <el-input v-model="scope.row.metricTons" :disabled="disabled" inputmode="decimal"
            @input="scope.row.metricTons = numberOnly($event)"></el-input>
        </template>
      </el-table-column>
      <el-table-column width="40">
        <template slot-scope="scope">
          <i v-if="!disabled && dataForm.listItem.length > 1" class="el-icon-circle-close cursor-pointer fs-15"
            style="color: red" @click="delProduct(scope.$index)"></i>
        </template>
      </el-table-column>
    </el-table>

    <!-- Remarks -->
    <div class="f-500 black mt-8">Remarks</div>
    <div class="item mt-4">
      <div class="fs-12 f-600" style="width: 100px">Before Loading:</div>
      <div class="value pl-5 w-full">
        <el-input v-model="dataForm.beforeRemarks" :maxlength="600" :rows="3" :disabled="disabled" show-word-limit
          type="textarea"></el-input>
      </div>
    </div>
    <div class="item mt-4">
      <div class="fs-12 f-600" style="width: 100px">After Loading:</div>
      <div class="value pl-5 w-full">
        <el-input v-model="dataForm.afterRemarks" :maxlength="600" :rows="3" :disabled="disabled" show-word-limit
          type="textarea"></el-input>
      </div>
    </div>
    <div class="pb-4"></div>

    <!-- Sign popup: name + drawn signature (like the after-loading form) -->
    <el-dialog title="Sign" :visible.sync="signDialogVisible" width="480px" append-to-body>
      <el-form label-position="top" size="small">
        <el-form-item label="Name" required>
          <el-input v-model="signName" placeholder="Enter name"></el-input>
        </el-form-item>
        <el-form-item label="Signature">
          <vue-sign ref="signPad" :width="430" :height="200" />
          <div class="mt-2 text-right">
            <el-button size="mini" plain @click="clearSign">Clear</el-button>
          </div>
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button size="small" plain @click="signDialogVisible = false">Cancel</el-button>
        <el-button size="small" type="primary" :loading="signing" @click="confirmSign">Confirm &amp; Sign</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
// Standalone Loss Control ullage report. Mirrors the original after-loading form
// (Before + After columns) minus the signature blocks. All fields are editable until signed.
import { getLossControlUllage, saveLossControlUllage, signLossControlUllage } from "@/services/form";
import { productAutocomplete } from "@/utils/tools";
import VueSign from "@/components/vue-sign.vue";

export default {
  name: "LossControlUllageReport",
  components: { VueSign },
  props: {
    id: {
      type: [Number, String],
      required: true,
    },
  },
  data() {
    return {
      dataForm: {
        lineContent: null,
        forward: null,
        aft: null,
        afterForward: null,
        afterAft: null,
        terminalLoaded: null,
        beforeRemarks: null,
        afterRemarks: null,
        signed: 0,
        signedBy: null,
        signTime: null,
        signImage: null,
        listItem: [{}],
      },
      port: [],
      center: [],
      starboard: [],
      showCenter: false,
      // true only when the SAVED report has both terminal loaded and ship-figure metric tons
      signable: false,
      autocomplete: null,
      saving: false,
      signing: false,
      signDialogVisible: false,
      signName: "",
    };
  },
  created() {
    this.autocomplete = productAutocomplete();
  },
  watch: {
    canSign() {
      this.emitState();
    },
  },
  computed: {
    disabled() {
      return this.dataForm.signed === 1;
    },
    // Sign only when the SAVED report has both mandatory fields (re-save required after edits)
    canSign() {
      return this.signable;
    },
    sections() {
      return [
        { key: "Port", label: "Port", rows: this.port },
        { key: "Center", label: "Center", rows: this.center },
        { key: "Starboard", label: "Starboard", rows: this.starboard },
      ];
    },
    lineContentOption: {
      get() {
        return this.dataForm.lineContent === null || this.dataForm.lineContent === "Include"
          ? "Include"
          : "Number";
      },
      set(val) {
        if (val === "Include") {
          this.dataForm.lineContent = "Include";
        } else if (this.dataForm.lineContent === "Include" || this.dataForm.lineContent === null) {
          this.dataForm.lineContent = 0;
        }
      },
    },
  },
  mounted() {
    this.getDetail();
  },
  methods: {
    headerClass(row) {
      // Highlight the Before/After sub-header cells
      const { columnIndex, rowIndex } = row;
      if (rowIndex === 1 && columnIndex >= 0 && columnIndex <= 3) return "blue";
      if (rowIndex === 1 && columnIndex >= 4 && columnIndex <= 7) return "gray";
    },
    getDetail() {
      getLossControlUllage({ nId: this.id }).then((res) => {
        const d = res.data || {};
        this.dataForm = {
          lineContent: d.lineContent ?? null,
          forward: d.forward ?? null,
          aft: d.aft ?? null,
          afterForward: d.afterForward ?? null,
          afterAft: d.afterAft ?? null,
          terminalLoaded: d.terminalLoaded ?? null,
          beforeRemarks: d.beforeRemarks ?? null,
          afterRemarks: d.afterRemarks ?? null,
          signed: d.signed ?? 0,
          signedBy: d.signedBy ?? null,
          signTime: d.signTime ?? null,
          signImage: d.signImage ?? null,
          listItem: d.products && d.products.length > 0 ? d.products : [{}],
        };
        // Signable is derived from the SAVED response only — not live edits.
        const savedTerminal = d.terminalLoaded != null && String(d.terminalLoaded).trim() !== "";
        const savedMetric = (d.products || []).some(
          (p) => p && p.metricTons != null && String(p.metricTons).trim() !== ""
        );
        this.signable = d.exists === true && savedTerminal && savedMetric;
        const tanks = d.tanks || [];
        this.port = tanks.filter((x) => x.descr === "Port");
        this.center = tanks.filter((x) => x.descr === "Center");
        this.starboard = tanks.filter((x) => x.descr === "Starboard");
        this.emitState();
      });
    },
    emitState() {
      this.$emit("loaded", {
        signed: this.dataForm.signed,
        signedBy: this.dataForm.signedBy,
        signTime: this.dataForm.signTime,
        signImage: this.dataForm.signImage || null,
        canSign: this.canSign,
      });
    },
    // Allow only a number, optionally with a single decimal point
    numberOnly(val) {
      let s = String(val == null ? "" : val).replace(/[^0-9.]/g, "");
      const i = s.indexOf(".");
      if (i !== -1) {
        s = s.slice(0, i + 1) + s.slice(i + 1).replace(/\./g, "");
      }
      return s;
    },
    clearItem(row) {
      if (this.disabled) return;
      ["product", "beforeUllage", "beforeVolume", "beforeTemp", "beforeWater",
        "afterUllage", "afterVolume", "afterTemp", "afterWater"].forEach((k) => (row[k] = ""));
    },
    delProduct(index) {
      if (this.disabled) return;
      this.dataForm.listItem.splice(index, 1);
    },
    async querySearchAllAsync(queryString, cb) {
      this.autocomplete.all();
      await this.autocomplete.search(queryString, cb);
    },
    async querySearchSection(key, queryString, cb) {
      if (key === "Port") this.autocomplete.port();
      else if (key === "Center") this.autocomplete.center();
      else if (key === "Starboard") this.autocomplete.starboard();
      await this.autocomplete.search(queryString, cb);
    },
    addMoreProduct(name) {
      this.autocomplete.add(name);
    },
    async deleteProduct(index, data) {
      await this.autocomplete.delete(data.id, data.name, (query) => {
        this.dataForm.listItem[index].name = query;
      });
    },
    async deleteTankProduct(row, data) {
      await this.autocomplete.delete(data.id, data.name, (query) => {
        row.product = query;
      });
    },
    buildPayload() {
      if (this.lineContentOption === "Include") {
        this.dataForm.lineContent = "Include";
      } else if (!this.dataForm.lineContent) {
        this.dataForm.lineContent = 0.0;
      }
      const tanks = [].concat(this.port, this.center, this.starboard).map((t) => ({
        descr: t.descr,
        formItem: t.formItem,
        product: t.product,
        beforeUllage: t.beforeUllage,
        beforeVolume: t.beforeVolume,
        beforeTemp: t.beforeTemp,
        beforeWater: t.beforeWater,
        afterUllage: t.afterUllage,
        afterVolume: t.afterVolume,
        afterTemp: t.afterTemp,
        afterWater: t.afterWater,
      }));
      return {
        nominationId: this.id,
        lineContent: this.dataForm.lineContent != null ? String(this.dataForm.lineContent) : null,
        forward: this.dataForm.forward,
        aft: this.dataForm.aft,
        afterForward: this.dataForm.afterForward,
        afterAft: this.dataForm.afterAft,
        terminalLoaded: this.dataForm.terminalLoaded,
        beforeRemarks: this.dataForm.beforeRemarks,
        afterRemarks: this.dataForm.afterRemarks,
        tanks,
        products: (this.dataForm.listItem || []).filter((p) => p && p.name),
      };
    },
    save(showMsg = true) {
      this.saving = true;
      return saveLossControlUllage(this.buildPayload())
        .then(() => {
          if (showMsg) this.$message.success("Save Success");
          this.getDetail();
        })
        .finally(() => {
          this.saving = false;
        });
    },
    handleSign() {
      const u = this.$store.state.userInfo || {};
      this.signName = u.nickName || u.userName || "";
      this.signDialogVisible = true;
      this.$nextTick(() => this.$refs.signPad && this.$refs.signPad.reset());
    },
    clearSign() {
      if (this.$refs.signPad) this.$refs.signPad.reset();
    },
    confirmSign() {
      if (!this.signName || !this.signName.trim()) {
        this.$message.error("Please enter name");
        return;
      }
      // generate() rejects/throws if nothing was drawn
      this.$refs.signPad.generate().then((img) => {
        this.signing = true;
        // Persist latest edits first, then lock with name + signature.
        this.save(false)
          .then(() => signLossControlUllage({
            nominationId: this.id,
            signedBy: this.signName.trim(),
            signImage: img,
          }))
          .then(() => {
            this.$message.success("Signed");
            this.signDialogVisible = false;
            this.getDetail();
          })
          .finally(() => {
            this.signing = false;
          });
      }).catch(() => {});
    },
  },
};
</script>

<style scoped lang="scss">
.form {
  font-size: 15px;
  color: #82889C;
  background-color: #fff;
}

.item {
  display: flex;
  align-items: center;

  .label {
    width: 60px;
  }

  .value {
    max-width: calc(100% - 50px);
  }
}

.tank {
  border-radius: 10px;
  border: 1px solid #CCE1FD;
}

::v-deep .blue {
  background-color: #E6FCFE !important;
  border-right: 1px solid #CCE1FD !important;

  .cell {
    background-color: #E6FCFE !important;
  }
}

::v-deep .gray {
  background-color: #E6EBFE !important;
  border-right: 1px solid #CCE1FD !important;

  .cell {
    background-color: #E6EBFE !important;
  }
}

// Ship Figure — grey header like the original
::v-deep .ship-figure th.el-table__cell {
  background-color: #F0F2F5 !important;
}

::v-deep .ship-figure th.el-table__cell .cell {
  background-color: #F0F2F5 !important;
}

::v-deep .el-input-group__append {
  background-color: #82889C;
  color: #fff;
  font-size: 12px;
  font-weight: 500;
}
</style>

<!-- Global: the autocomplete dropdown is appended to <body>, so it can't be scoped -->
<style>
.lc-product-popper {
  min-width: 240px !important;
}

.lc-product-popper .value {
  white-space: normal;
  word-break: break-word;
}
</style>
